<template>
  <div>
    <create-card route_back="ModalityList" :model_name="solution_map[$route.params.solution]" :saving="saving" return_params>
      <template slot="form">
        <v-stepper class="elevation-0" v-model="stepper" vertical>

          <v-stepper-step :editable="stepper > 1" :complete="stepper > 1" complete-icon="mdi-pencil" step="1">
            Identificação
            <small>Nome e documentos</small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card class="ma-1">
              <v-card-text>
                <ModalityInfosForm :modality_infos="one_modality" ref="form1"></ModalityInfosForm>
              </v-card-text>
            </v-card>
            <v-container class="d-flex justify-center">
              <v-btn text disabled><v-icon x-large>mdi-arrow-up-bold</v-icon></v-btn>
              <v-btn text class="success--text" @click="verifyForm(1)"><v-icon x-large>mdi-arrow-down-bold</v-icon></v-btn>
            </v-container>
          </v-stepper-content>

          <v-stepper-step :editable="stepper > 2" :complete="stepper > 2" step="2">Contatos</v-stepper-step>
          <v-stepper-content step="2">
            <v-card class="ma-1">
              <v-card-text>
                <contact-form ref="form2" :contact="one_modality.contact"></contact-form>
              </v-card-text>
            </v-card>
            <v-container class="d-flex justify-center">
              <v-btn text class="error--text" @click="stepper = 1"><v-icon x-large>mdi-arrow-up-bold</v-icon></v-btn>
              <v-btn text class="success--text" @click="verifyForm(2)"><v-icon x-large>mdi-arrow-down-bold</v-icon></v-btn>
            </v-container>
          </v-stepper-content>

          <v-stepper-step :editable="stepper > 3" :complete="stepper > 3" step="3">
            Endereço
            <small>Digite o CEP para preenchimento automático</small>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-card class="ma-1">
              <v-card-text>
                <address-form ref="form3" :address="one_modality.address"></address-form>
              </v-card-text>
            </v-card>
            <v-container class="d-flex justify-center">
              <v-btn text class="error--text" @click="stepper = 2"><v-icon x-large>mdi-arrow-up-bold</v-icon></v-btn>
              <v-btn text class="success--text" @click="verifyForm(3)" v-if="$route.params.solution == 'retail'"><v-icon x-large>mdi-arrow-down-bold</v-icon></v-btn>
            </v-container>
          </v-stepper-content>

          <v-stepper-step :editable="stepper > 4" :complete="stepper > 4" step="4" v-if="$route.params.solution == 'retail'"> Créditos e limites </v-stepper-step>
          <v-stepper-content step="4" :complete="stepper > 4" v-if="$route.params.solution == 'retail'">
            <v-card class="ma-1">
              <v-card-text>
                <CompanyCreditForm ref="form4" :company_credit="company_credit"></CompanyCreditForm>
              </v-card-text>
            </v-card>
            <div>
              <v-btn text @click="stepper = 3"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
              <v-btn text class="success--text" @click="verifyForm(4)"><v-icon x-large>mdi-arrow-down-bold</v-icon></v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-step  step="5" v-if="$route.params.solution == 'retail'">Próprio Cliente</v-stepper-step>
          <v-stepper-content step="5" :complete="stepper > 5" v-if="$route.params.solution == 'retail'">
            <v-card class="ma-1">
              <v-card-text>
                <ModalityOwnClientForm ref="form5" :model="one_modality"></ModalityOwnClientForm>
              </v-card-text>
            </v-card>
            <div>
              <v-btn text @click="stepper = 4"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
            </div>
          </v-stepper-content>
          <v-row v-if="can_save">
            <v-col cols="12" style="margin-left: 62px;">
              <f-btn save @click="saveModalityInfos" ></f-btn>
            </v-col>
          </v-row>
        </v-stepper>
      </template>
    </create-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'CreateModality',
  components: {
    ModalityInfosForm: () => import('./register/ModalityInfosForm'),
    ContactForm: () => import('@/_backoffice/_registrations/components/shared/forms/ContactForm.vue'),
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
    CreateCard: ()=> import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    CompanyCreditForm: ()=> import("@/_backoffice/_registrations/components/companies/forms/CompanyCreditForm.vue"),
    ModalityOwnClientForm: ()=> import("@/_backoffice/_registrations/components/modality/register/ModalityOwnClientForm.vue"),
  },
  data() {
    return {
      stepper: 1,
      saving: false,
      company_credit: {},
      solution_map: {
        'retail': 'Galpão',
        'wholesale': 'Grandes Cargas',
      }
    }
  },
  methods: {
    verifyForm(number) {
      return this.$refs[`form${number}`].validate() ? this.stepper = (number + 1) : null
    },
    checkValidations(){
      let valid = true
      let steps = this.$route.params.solution == 'retail' ? 5 : 3
      for (let i = 1 ; i <= steps ; i++) {
        valid = this.$refs[`form${i}`].validate() && valid
      }
      return valid
    },
    prepareModality(){
      return {
        ...this.one_modality,
        solution: this.$route.params.solution,
      }
    },
    saveModalityInfos () {
      if (this.checkValidations()) {
        this.swallConfirmation({
          title: `Deseja cadastrar ${this.solution_map[this.$route.params.solution]}?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let modality = this.prepareModality()
            this.saving = true
            Api.Modality.create(modality).then(r => {
              this.addNotification({type: 'success', msg: `${this.solution_map[this.$route.params.solution]} cadastrado com sucesso`})
              this.$router.push({name: this.redirect_to, params: {id: r.data.id, solution: this.$route.params.solution}})
            }).catch(err => {
              if( err?.response?.data?.errors?.document?.[0] == "has already been taken" ){
                this.addNotification({type: 'error', msg: "CNPJ já cadastrado!"})
              }else if(err?.response?.data?.errors?.name?.[0] == "has already been taken"){
                this.addNotification({type: 'error', msg: "Nome já cadastrado!"})
              }else{
                this.addNotification({type: 'error', msg: err})
              }
              console.log(err)
            }).finally(()=>{
              this.saving = false
            })
          }
        })
      }else{
        this.addNotification({type: 'info', msg: 'Preencha todos os campos corretamente.'})
      }
    },
    // resetForm(){
    //   this.modalityCreated()
    //   for(let i = 1 ; i <= 4 ; i++ ){
    //     this.$refs[`form${i}`].resetValidation()
    //   }
    //   this.company_credit = {}
    //   this.stepper = 1
    // },
    ...mapActions({
      clearOneModality: 'Modality/clearOneModality',
      modalityCreated: 'Modality/create',
    }),
  },
  beforeDestroy() {
    this.clearOneModality()
  },
  beforeCreate () {
    if(!this.$route.params.solution){
      this.$router.push({name: 'Home'})
    };
  },
  computed: {
    redirect_to(){
      if (this.$route.params.solution.includes('retail')) return 'ShowModalityRegister'
      if (this.$route.params.solution.includes('wholesale')) return 'ShowModalityRegisterWholesale'
    },
    can_save(){
      if(this.$route.params.solution == 'retail' && this.stepper == 5){
        return true
      }else if(this.$route.params.solution == 'wholesale' && this.stepper == 3){
        return true
      }else{
        return false
      }
    },
    ...mapState({
      one_modality: state => state.Modality.one_modality
    })
  },
}
</script>
